export default __webpack_public_path__ + "static/media/Ficha Técnica - Polpa Melancia Orgânica.6898576f.pdf";